import { DotLegalEmptyState, DotLegalPaper, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { TableCell, TableRow } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";
import DotLegalTableWithFilterBar from "@common/components/dotLegalTableWithFilterBar/DotLegalTableWithFilterBar";
import EmptyState from "@common/svgs/emptyStates/emptyState_1.svg?react";
import useProcessingActivityDataCategoriesTab, { ProcessingActivityDataCategoryTableRow } from "./ProcessingActivityDataCategoriesTab.hooks";

export interface IProcessingActivityDataCategoriesTab {
    processingActivityId: string;
}

function ProcessingActivityDataCategoriesTab(props: IProcessingActivityDataCategoriesTab) {
    const { translateString } = useTranslation();
    const { rows, isLoading, hasData, textColumns, getFilterOptions, onFilterChange, pinnedFilterIds, onPinnedFilterIdsChange, hasActiveFilters } =
        useProcessingActivityDataCategoriesTab(props);

    function getHeaders() {
        const headers = Array<ITableHeader<ProcessingActivityDataCategoryTableRow>>();
        headers.push({ property: "name", text: translateString("dataCategory"), align: "left", showOnMobile: true });
        headers.push({ property: "classification", text: translateString("classification"), align: "left", showOnMobile: true });
        textColumns.forEach((column) => headers.push({ property: column.id, text: column.label, align: "left", showOnMobile: true }));
        return headers;
    }

    return (
        <DotLegalPaper>
            {hasData ? (
                <DotLegalTableWithFilterBar
                    headers={getHeaders()}
                    defaultOrderBy={"name"}
                    defaultOrder={"asc"}
                    clickableRows={false}
                    data={rows}
                    isLoading={isLoading}
                    filterBar={{
                        isLoading: isLoading,
                        filterData: getFilterOptions(),
                        fetchFilterData: true,
                        onMenuClose: onFilterChange,
                        onRemove: onFilterChange,
                        pinnedFilterIds: pinnedFilterIds,
                        onPinnedFilterIdsChange: onPinnedFilterIdsChange,
                    }}
                    emptyText={translateString(hasActiveFilters ? "noDataMatchingCriteria" : "noData")}
                    renderRow={(row) => (
                        <TableRow key={row.rowId}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>{row.classification}</TableCell>
                            {textColumns.map((column) => (
                                <TableCell key={column.id}>{row[column.id]}</TableCell>
                            ))}
                        </TableRow>
                    )}
                    paginationLabelOf={""}
                    rowsPerPage={30}
                />
            ) : (
                <DotLegalEmptyState icon={<EmptyState />} text={translateString("noDataCategoriesOnProcessingActivity")} />
            )}
        </DotLegalPaper>
    );
}

export default ProcessingActivityDataCategoriesTab;
